import { parseURLParams } from '@offerzen/pinata-shame'

export const companyStateMap = {
  onboarding: {
    id: 'onboarding',
    label: 'Onboarding',
  },
  onboarding_completed: {
    id: 'onboarding_completed',
    label: 'Onboarding completed',
  },
  setup_call: {
    id: 'setup_call',
    label: 'Setting up call',
  },
  setup_meeting: {
    id: 'setup_meeting',
    label: 'Setting up meeting',
  },
  unresponsive: {
    id: 'unresponsive',
    label: 'Unresponsive',
  },
  rejected: {
    id: 'rejected',
    label: 'Rejected',
  },
  call_scheduled: {
    id: 'call_scheduled',
    label: 'Call scheduled',
  },
  completing_profile: {
    id: 'completing_profile',
    label: 'Completing profile',
  },
  ready_to_go_live: {
    id: 'ready_to_go_live',
    label: 'Ready to go live',
  },
  accepting_terms: {
    id: 'accepting_terms',
    label: 'Accepting terms',
  },
  live: {
    id: 'live',
    label: 'Live',
  },
  dormant: {
    id: 'dormant',
    label: 'Dormant',
  },
  junk_data: {
    id: 'junk_data',
    label: 'Junk Data',
  },
}

export const companyPreLiveStates = [
  'onboarding',
  'onboarding_completed',
  'setup_call',
  'setup_meeting',
  'call_scheduled',
  'completing_profile',
  'ready_to_go_live',
  'accepting_terms',
]

export const impersonatedHiringTeam = history => {
  const hiringTeamId = parseURLParams(history.location.search).current_hiring_team_id

  if (hiringTeamId) {
    return `?current_hiring_team_id=${hiringTeamId}`
  }
  return ''
}

const CompanyState = {
  Onboarding: 'onboarding',
  OnboardingCompleted: 'onboarding_completed',
  SetupCall: 'setup_call',
  SetupMeeting: 'setup_meeting',
  Unresponsive: 'unresponsive',
  Rejected: 'rejected',
  CallScheduled: 'call_scheduled',
  CompletingProfile: 'completing_profile',
  ReadyToGoLive: 'ready_to_go_live',
  AcceptingTerms: 'accepting_terms',
  Live: 'live',
  Dormant: 'dormant',
  JunkData: 'junk_data',
}

Object.freeze(CompanyState)

export { CompanyState }
